<mat-card>
  <app-card-header
    icono="assignment"
    [title]="title"
    [draggable]="false"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form id="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content
        [class.cardContentFullscreen]="!dialogRef"
        [class.cardContentDialog]="dialogRef"
        class="card-content-crear"
      >
        <!-- Datos Básicos -->
        <app-content-card
          title="Datos del Servicio"
          icon="assignment"
          color="blue"
        >
          <section class="inputs-group">
            <!-- Cliente -->
            @if (!helper.esClienteFinal()) {
              @if (!id) {
                <app-cliente-selector
                  formControlName="idCliente"
                  style="width: 100%"
                  (clienteChange)="onClienteChange($event)"
                ></app-cliente-selector>
              }
            }

            <!-- Tipo -->
            <ng-select
              [items]="tipos"
              bindLabel="tipo"
              formControlName="tipo"
              placeholder="Tipo"
              style="width: 100%"
              multiple="false"
              searchable="true"
              (change)="onTipoChange($event)"
              appendTo="body"
            ></ng-select>

            <!-- Vehículo / Colectivo -->
            <ng-select
              [items]="activos"
              bindLabel="identificacion"
              bindValue="_id"
              formControlName="idActivo"
              [placeholder]="
                categoria === 'Colectivo' ? 'Colectivo' : 'Vehículo'
              "
              [notFoundText]="
                categoria === 'Colectivo'
                  ? 'No hay colectivos creados'
                  : 'No hay vehículos creados'
              "
              style="width: 100%"
              multiple="false"
              searchable="true"
              appendTo="body"
            ></ng-select>
          </section>
        </app-content-card>

        <!-- Conductor y Proveedor -->
        <app-content-card
          title="Conductor y Proveedor"
          icon="account_box"
          color="green"
        >
          <section class="inputs-group">
            <!-- Chofer -->
            @if (categoria === 'Colectivo') {
              <app-usuario-selector
                formControlName="idUsuario"
                [funciones]="['Chofer']"
                [placeholder]="'Chofer'"
                [showCrearBtn]="
                  helper.tienePermiso('Colectivos - Crear choferes')
                "
                (usuarioChange)="
                  form?.patchValue({
                    nombreChofer:
                      $event?.datosPersonales?.nombre ||
                      $event?.usuario ||
                      null,
                  })
                "
              ></app-usuario-selector>
            }
            <!-- Conductor -->
            @if (categoria === 'Vehiculo') {
              <app-usuario-selector
                formControlName="idUsuario"
                [funciones]="['Conductor']"
                [placeholder]="'Conductor'"
                [showCrearBtn]="
                  helper.tienePermiso('Vehículos - Crear conductor')
                "
                (usuarioChange)="
                  form?.patchValue({
                    nombreChofer:
                      $event?.datosPersonales?.nombre ||
                      $event?.usuario ||
                      null,
                  })
                "
              ></app-usuario-selector>
            }
          </section>

          <section class="inputs-group">
            <!-- Proveedor -->
            <div style="width: 100%; display: flex; gap: 8px">
              @if (proveedores && proveedores.length >= 0) {
                <ng-select
                  [items]="proveedores"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idProveedor"
                  placeholder="Proveedor"
                  [notFoundText]="'No hay proveedores creados'"
                  style="flex: 1"
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                ></ng-select>
              }
              <app-button
                matType="mat-fab"
                tooltip="Crear Proveedor"
                color="primary"
                (click)="this.crearProveedor()"
                icon="add"
              ></app-button>
            </div>
          </section>
        </app-content-card>

        <!-- Registro -->
        <app-content-card title="Registro" icon="ballot" color="orange">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Fecha</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="fechaRealizacion"
              />
              <mat-icon matPrefix>event</mat-icon>
              <mat-hint>DD/MM/YYYY</mat-hint>
              <button
                irxBotonIcono
                tamano="compacto"
                matIconSuffix
                tooltip="Elegir fecha"
                (click)="picker.open()"
              >
                <mat-icon>calendar_month</mat-icon>
              </button>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Kilometraje</mat-label>
              <mat-icon matPrefix>speed</mat-icon>
              <input
                matInput
                type="number"
                formControlName="kmDelMantenimiento"
              />
            </mat-form-field>

            @if (!esCombustible) {
              <mat-form-field style="width: 100%">
                <mat-label>Costo Total</mat-label>
                <mat-icon matPrefix>payments</mat-icon>
                <input matInput type="number" formControlName="costo" />
              </mat-form-field>
            }
          </section>
        </app-content-card>

        <!-- Campos específicos para Combustible -->
        @if (esCombustible) {
          <app-content-card
            title="Combustible"
            icon="local_gas_station"
            color="red"
          >
            <section class="inputs-group">
              <mat-form-field style="width: 100%">
                <mat-label>Litros Cargados</mat-label>
                <mat-icon matPrefix>local_gas_station</mat-icon>
                <input
                  matInput
                  type="number"
                  step="0.01"
                  formControlName="litrosCargados"
                  (focus)="campoFocused = 'litrosCargados'"
                  (input)="calcularCombustible('litrosCargados')"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%">
                <mat-label>Precio por Litro</mat-label>
                <mat-icon matPrefix>sell</mat-icon>
                <input
                  matInput
                  type="number"
                  step="0.01"
                  formControlName="precioPorLitro"
                  (focus)="campoFocused = 'precioPorLitro'"
                  (input)="calcularCombustible('precioPorLitro')"
                />
              </mat-form-field>
              <mat-form-field style="width: 100%">
                <mat-label>Costo Total</mat-label>
                <mat-icon matPrefix>payments</mat-icon>
                <input
                  matInput
                  type="number"
                  step="0.01"
                  formControlName="costo"
                  (focus)="campoFocused = 'costo'"
                  (input)="calcularCombustible('costo')"
                />
              </mat-form-field>
            </section>
            <div class="inputs-group combustible-hint">
              <mat-icon>info</mat-icon>
              <span>
                Ingresá 2 valores y el tercero se calculará automáticamente
              </span>
            </div>
          </app-content-card>
        }

        <!-- Detalles -->
        <app-content-card title="Detalles" icon="description" color="purple">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Detalles</mat-label>
              <mat-icon matPrefix>notes</mat-icon>
              <textarea matInput formControlName="detalles"></textarea>
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Fotos -->
        <app-content-card title="Fotos" icon="photo_library" color="teal">
          <section class="inputs-group">
            <app-upload-file
              style="width: 100%"
              [allowMultiple]="true"
              [maxFiles]="10"
              textoBoton="Agregar Foto"
              [urls]="form.get('fotos')?.value || []"
              (urlsChange)="form?.patchValue({ fotos: $event })"
            ></app-upload-file>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.helper.volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          [disabled]="loading || !this.form.valid"
          matType="mat-fab extended"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
